import type { HoursScheduleRow } from './splitHoursLines';

const CLOSED_RE = /geschlossen|closed|ruhetag|đóng|nghỉ/i;

function firstOpenSitting(rows: HoursScheduleRow[]): { day: string; times: string[] } | undefined {
  const start = rows.findIndex((row) => row.time && !CLOSED_RE.test(row.time));
  const index = start >= 0 ? start : 0;
  const row = rows[index];
  if (!row) return undefined;
  const times = [row.time];
  for (let i = index + 1; i < rows.length; i += 1) {
    const next = rows[i];
    if (!next || next.day) break;
    if (next.time && !CLOSED_RE.test(next.time)) times.push(next.time);
  }
  return { day: row.day, times };
}

/** One sitting line for Visit and Desk — not a second hours table. */
export function contactHoursLine(rows: HoursScheduleRow[], raw: string): string {
  const sitting = firstOpenSitting(rows);
  if (sitting) {
    return `${sitting.day} ${sitting.times.join(' · ')}`.trim();
  }
  return raw.split(/\r?\n/)[0]?.trim() ?? '';
}

/** Hours chip — same first-sitting text as Visit/Desk (includes day label). */
export function contactHoursChip(rows: HoursScheduleRow[], raw: string): string {
  return contactHoursLine(rows, raw);
}

/** Landmark chip: the clause before an em dash. */
export function contactLandmark(directions: string): string {
  const head = directions.split(/\s[—–]\s/)[0]?.trim();
  return head || directions.trim();
}
